<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<g id="Group_44768" data-name="Group 44768" transform="translate(-20 -1026)">
			<rect id="Rectangle_14874" data-name="Rectangle 14874" width="30" height="30" rx="8" transform="translate(20 1026)" fill="#7e7fe7" />
			<path
				id="Path_30451"
				data-name="Path 30451"
				d="M3.75,6.75h16.5M3.75,12h16.5M3.75,17.25h9.909"
				transform="translate(23 1029)"
				fill="none"
				stroke="#fff"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ShowPlaylistSvg',
};
</script>

<style scoped lang="scss"></style>
